import React, { FC } from 'react'

import { SearchListProps } from './SearchList.props'
import { TSearchResults } from 'shared/types'

import SearchItem from '../SearchItem/SearchItem'
import { FollowButton } from 'modulesCommon/Follow/containers'
import { ConditionRender } from 'components'

const SearchList: FC<SearchListProps> = ({ listItems, withFollow, onItemChooseHandler }) => {
  return (
    <ul className="search-menu__list">
      {listItems?.map((item: TSearchResults) => (
        <li key={item.id} className="search-menu__item" onClick={onItemChooseHandler(item)}>
          {'artist' in item && (
            <SearchItem
              title={item?.artist?.name}
              subtitle={item?.name}
              spotifyId={item?.artist?.spotify_id}
              facebookId={item?.artist?.facebook_id}
              isSpaceRole={item?.isSpaceRole}
              zone={item?.zone}
            />
          )}
          <ConditionRender
            condition={item.__typename === 'Campaign' && withFollow}
            component={
              <FollowButton
                projectId={`${item.id}`}
                userId={item?.owner_id}
                projectName={`${item?.artist?.name}, ${item?.name}`}
              />
            }
          />
        </li>
      ))}
    </ul>
  )
}

export default SearchList
